import {
  AccomodationAccomodationTypeStaysIcon,
  AmenitiesBookingBookerDrivableIcon,
  GeneralHeartFilledIcon,
  GeneralInstantBookIcon,
} from '@outdoorsyco/bonfire';
import React from 'react';

import css from './MapMarker.module.css';

export enum MapMarkerTypes {
  SINGLE = 'single',
  GROUP = 'group',
}

interface IProps {
  /**
   * A function that gets called when the marker is clicked
   */
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * A function that gets called when the mouse entered the marker
   */
  onMouseEnter?: () => void;
  /**
   * A function that gets called when the mouse leave the marker
   */
  onMouseLeave?: () => void;
  /**
   * Boolean to represent if the listing is instant book
   */
  isInstantBook?: boolean;
  /**
   * Boolean to represent if the listing is unavailable
   */
  isUnavailable?: boolean;
  /**
   * Boolean to represent if the listing or listing group is for stays.
   */
  isStay?: boolean;
  /**
   * Boolean to represent if the marker is active
   */
  isActive?: boolean;
  /**
   * The type of marker to display
   */
  type: MapMarkerTypes;
  /**
   * The content of the marker (e.g. price, number of listings)
   */
  children?: string | number;
  /**
   * Boolean to represent if the marker is on the wishlist
   */
  isOnWishlist?: boolean;
}

const MapMarker: React.FC<IProps> = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  isInstantBook = false,
  isUnavailable = false,
  isStay = false,
  isActive = false,
  type,
  children,
  isOnWishlist = false,
}) => {
  const isGroup = type === MapMarkerTypes.GROUP;
  const listingCount = isGroup ? children : 1;

  return (
    <button
      data-testid="map-pin"
      data-unavailable={String(isUnavailable)}
      data-instantbook={String(isInstantBook)}
      data-group={String(isGroup)}
      data-listing-count={listingCount}
      data-active={String(isActive)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`relative inline-block px-3 py-2 bg-white rounded-tag shadow-300 text-gray-850 ${css.marker}`}>
      <span className="flex font-medium autoType300 text">
        {isInstantBook && type === MapMarkerTypes.SINGLE && (
          <span
            className="inline-flex items-center mr-1 text-canvas-300"
            data-testid="map-pin-instant-icon">
            <GeneralInstantBookIcon fontSize={16} />
          </span>
        )}
        {isGroup && (
          <span className="inline-block mr-2" data-testid="map-pin-rv-icon">
            {isStay ? (
              <AccomodationAccomodationTypeStaysIcon fontSize={20} />
            ) : (
              <AmenitiesBookingBookerDrivableIcon fontSize={20} />
            )}
          </span>
        )}
        {children}
        {isOnWishlist && (
          <span className="flex items-center ml-2" data-testid="map-pin-wishlist-icon">
            <GeneralHeartFilledIcon fontSize={16} />
          </span>
        )}
      </span>
    </button>
  );
};

export default MapMarker;
